import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Text from '../../Text'

import * as styles from './ChatroomMessageDeleted.module.css'

function ChatroomMessageDeleted({ message }) {
  const { t } = useTranslation()

  const isOwnMessage = Boolean(message?.is_my_message)

  const rootClassName = classNames(styles.chatroomMessageDeleted, {
    [styles.chatroomMessageDeletedOwn]: isOwnMessage,
  })

  const cardClassName = classNames(styles.card, {
    [styles.cardOwn]: isOwnMessage,
  })

  return (
    <div className={rootClassName}>
      <div className={styles.column}>
        <div className={cardClassName}>
          <Text isSecondary>{t('Chatroom.MessageDeletedKey')}</Text>
        </div>
      </div>
    </div>
  )
}

export default ChatroomMessageDeleted
